import { OperatorConfig } from "..";

// PROD
const sourcesConfig: OperatorConfig = {
  backoffice: {
    display: {
      "sidebar.menu.management.visits": true,
      "sidebar.menu.building.documents": true,
      "feature.ai": true,

      // quotes
      "sidebar.menu.quote": true,
      "sidebar.menu.quote.quotes": true,
      "sidebar.menu.quote.quote.requests": true,
      // inspection round
      "sidebar.menu.inspection": true,
      "sidebar.menu.inspection.checkpoints": true,
      "sidebar.menu.inspection.round_forms": true,
      "sidebar.menu.inspection.rounds": true,
    },
  },
};

export default sourcesConfig;
